import gql from "graphql-tag";

export const COMPLETED_SURVEY_RESULTS = gql`
  query employee($id: ID!) {
    employee(id: $id) {
      completedSurveyResults {
        id
        publishedSurvey {
          survey {
            id
            name
            color
          }
          anonymous
          endDateTime
          publishDateTime
          uncompletedEvaluators {
            id
          }
        }
      }
    }
  }
`;

export const SURVEY_RESULT = gql`
  query surveyResult($id: ID!) {
    surveyResult(id: $id) {
      id
      answers {
        question {
          id
        }
        questionChoices {
          id
          rank
          name
          other
          imageUrl
        }
        answer
      }
      publishedSurvey {
        endDateTime
        survey {
          id
          color
          name
          description
          questionCount
          sections {
            id
            name
            description
            rank
            questions {
              id
              name
              rank
              answerType
              imageUrl
              required
              firstTag
              lastTag
              choices {
                id
                name
                imageUrl
                other
                rank
              }
            }
          }
        }
      }
    }
  }
`;
